define('headerPhoneView',[
  'app',
  'module',
  'marionette',
  'underscore',
  'settings',
  'phoneParserView',
  'googlePhoneUtil',
  'template!headerPhoneView'
], function (
  App,
  Module,
  Marionette,
  _,
  Settings,
  PhoneParserView,
  GooglePhoneUtil,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'phone-view',

    ui: {
      phone: '.phone',
      numberPanel: '.number-panel',
      numberPanelPhoneNumber: '.number-panel .phone-number',
      phoneNumberButton: '.number-panel .numbers .item',
      phoneNumber: '.number-panel .phone-number',
      numberPanelCallButton: '.number-panel .call-button',
      validationPhoneMsg: '.number-panel .validate-phone-message'
    },

    events: {
      'click @ui.phone': 'onOpenNumberPanel',
      'click @ui.phoneNumberButton': 'onPhoneNumberClick',
      'paste @ui.phoneNumber': 'onPhoneNumberParse',
      'click @ui.numberPanelCallButton': 'onPhoneCall'
    },

    onShow: function () {
      App.on('phone:numbering', _.bind(function (value) {
        var phoneNumber;
        if (value.country) {
          var PNF = GooglePhoneUtil.PhoneNumberFormat;
          var phoneUtil = GooglePhoneUtil.PhoneNumberUtil.getInstance();
          var country = 'BE';
          var gglPhone = phoneUtil.parse(value.phoneNumber, country);
          if (phoneUtil.isValidNumberForRegion(gglPhone, country)) {
            this.ui.validationPhoneMsg.hide();
          }
          phoneNumber = phoneUtil.format(gglPhone, PNF.E164);
        } else {
          phoneNumber = value.phoneNumber;
        }

        this.openInThreeCx(phoneNumber);
      }, this));

      $(document).on('click', _.bind(function (event) {
        if (!event.target.closest('.number-panel') && !event.target.closest('.keyboard-pannel')) {
          this.closeNumberPanel();
        }
      }, this));

      $(document).on('keydown', _.bind(function (event) {
        if (event.keyCode === 27 &&
            !event.target.closest('.number-panel') &&
            !event.target.closest('.keyboard-pannel')) {
          this.closeNumberPanel();
        }
      }, this));
    },

    onRender: function () {
      this.$el.attr('data-status', 'phone');
    },

    onOpenNumberPanel: function (e) {
      e.stopPropagation();

      if (this.ui.phone.hasClass('activated')) {
        this.closeNumberPanel();
      } else {
        this.openNumberPanel();
      }
    },

    openNumberPanel: function () {
      this.ui.validationPhoneMsg.hide();
      this.ui.numberPanelPhoneNumber.show();
      this.ui.numberPanelCallButton.addClass('activated');

      this.ui.numberPanel.addClass('activated');
      this.ui.phone.addClass('activated');
      this.ui.numberPanelPhoneNumber.select().focus();
    },

    closeNumberPanel: function () {
      if (this.ui.numberPanel && this.ui.numberPanel.removeClass) {
        this.ui.numberPanel.removeClass('activated');
      }
      if (this.ui.phone && this.ui.phone.removeClass) {
        this.ui.phone.removeClass('activated');
      }
    },

    onPhoneNumberClick: function (event) {
      this.addPhoneNumber($(event.currentTarget).data('id'));
    },

    onPhoneNumberParse: function (e) {
      e.preventDefault();
      var value = (e.originalEvent.clipboardData || window.clipboardData).getData('text');

      PhoneParserView.prototype.parse({
        number: value,
        onParsed: _.bind(function (value) {
          this.ui.phoneNumber.val(value);
        }, this)
      });
    },

    addPhoneNumber: function (value) {
      var phoneNumber = this.ui.phoneNumber.val();
      this.ui.phoneNumber.val(phoneNumber + value);
    },

    onPhoneCall: function () {
      var regex = /^\+(?:[\d]*)$/;
      var value = this.ui.phoneNumber.val();
      value = value.replace(/\s/g, '');
      value = value.replaceAll('.', '');
      value = value.replaceAll('/', '');
      if (regex.test(value)) {
        this.ui.validationPhoneMsg.hide();
        this.openInThreeCx(value);
        this.closeNumberPanel();
      } else {
        this.ui.validationPhoneMsg.show();
      }
    },

    openInThreeCx: function (phoneNumber) {
      var dialerUrl = Settings.get('threeCxDialerUrl');
      if (!dialerUrl) {
        return;
      }
      window.open(dialerUrl + '?phone=' + encodeURIComponent(phoneNumber), '_blank');
    }
  });
});

